import http from '@/http/service'
 

export default function BuscarServicosByNome(nome=""){

    return http.get("/admin/servicos",{ params:{ nome } })

}